import AdministrationOrganizations from './AdministrationOrganizations'

export default AdministrationOrganizations
